import IDTFRecordingInfoPane from './IDTFRecordingInfoPane';

export default IDTFRecordingInfoPane;



// WEBPACK FOOTER //
// ./src/views/components/IDTFRecordingInfoPane/index.js